import { useTrackers } from '@ps/web-shared-analytics';
import { Translation } from '@ps/web-shared-components';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { useSportsMenuWidget } from '../../../../model';

import { TXTWCL_Clear_All, TXTWCL_Search_History } from './PreviousSearchResults.messages.json';
import styles from './PreviousSearchResults.scss';
import { getPreviousSearchResults } from './utils/get-previous-results';
import { updatePreviousSearchResults } from './utils/update-previous-search-results';

export function PreviousSearchResults() {
  const { widgetDispatch, widgetSelect } = useSportsMenuWidget();
  const { buttonPressed } = useTrackers();
  const previousResults = useSelector(widgetSelect.previousSearchResults);

  useEffect(() => {
    const storedResults = getPreviousSearchResults();

    widgetDispatch.updatePreviousSearchResults(storedResults);
  }, [widgetDispatch]);

  const handlePrevResultClick = (query: string) => {
    const updatedPrevSearchResults = updatePreviousSearchResults(query);

    buttonPressed({ buttonName: query });
    widgetDispatch.updateSearchQuery(query);
    widgetDispatch.updatePreviousSearchResults(updatedPrevSearchResults);
  };

  if (previousResults.length === 0) {
    return null;
  }

  return (
    <div className={styles.container}>
      <h2 className={styles.header}>
        <p className={styles.headerTitle}>
          <Translation {...TXTWCL_Search_History} />
        </p>
        <button
          type="button"
          onClick={() => {
            localStorage.removeItem('previousSearchResults');
            widgetDispatch.updatePreviousSearchResults([]);
            buttonPressed({ buttonName: 'Clear All' });
          }}
          className={styles.clearResults}
        >
          <Translation {...TXTWCL_Clear_All} />
        </button>
      </h2>
      <ul className={styles.results}>
        {previousResults.map((prevResult) => (
          <li key={prevResult} className={styles.resultContainer}>
            <button
              onClick={() => {
                handlePrevResultClick(prevResult);
              }}
              className={styles.result}
              type="button"
            >
              {prevResult}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
